import {charcoal} from '../sass/base/_exports.sass';

export const MessagesLineIcon = (props) => {
  const {color = charcoal, className = '', ratio = 1} = props;

  // default dimensions
  const width = 32;
  const height = 34;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Fix me!
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.16265 20L2.22265 24.6667V4C2.22265 3.64637 2.36313 3.30724 2.61319 3.05719C2.86323 2.80715 3.20237 2.66667 3.55599 2.66667H23.556C23.9096 2.66667 24.2488 2.80715 24.4988 3.05719C24.7488 3.30724 24.8893 3.64637 24.8893 4V20H8.16265ZM7.23999 17.3333H22.2227V5.33333H4.88932V19.18L7.23999 17.3333ZM11.556 22.6667H25.2053L27.556 24.5133V10.6667H28.8893C29.2429 10.6667 29.5821 10.8071 29.8321 11.0572C30.0821 11.3072 30.2227 11.6464 30.2227 12V30L24.2827 25.3333H12.8893C12.5357 25.3333 12.1966 25.1928 11.9465 24.9428C11.6965 24.6928 11.556 24.3536 11.556 24V22.6667Z"
        fill={color}
      />
    </svg>
  );
};
